export default "__VITE_ASSET__BMVj2Gn7__"